import { createFileRoute, Outlet } from "@tanstack/react-router";
import { CoachShell } from "@/components/CoachShell";

export const Route = createFileRoute("/coach-portal")({
  head: () => ({ meta: [{ title: "Coach-portal — Inkubera" }] }),
  component: () => (
    <CoachShell>
      <Outlet />
    </CoachShell>
  ),
});
